import '../../../pages/Admin/Admin.scss';

import { Input } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

export const Area9EntrypointInput = observer(() => {
  const ls = useStores().lessonEditorStore;

  return (
    <div className='admin-edit-section'>
      <h2>Area 9 entrypoint</h2>
      <div className='inputs-container wide-input'>
        <Input
          label='Entrypoint'
          type='text'
          value={ls.lesson.enterpoint ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => (ls.lesson.enterpoint = e.currentTarget.value)}
        />
      </div>
    </div>
  );
});

export default Area9EntrypointInput;
